import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import './output.css';

// 引入 VConsole 用于真机调试
import VConsole from 'vconsole';
import { VCONSOLE_ENABLED, VCONSOLE_CONFIG } from './config/vconsole.config';

// 初始化 VConsole
let vConsoleInstance = null;

const initVConsole = () => {
  // 检查配置开关
  if (VCONSOLE_ENABLED) {
    try {
      // 延迟初始化，确保 DOM 完全准备好
      setTimeout(() => {
        if (!vConsoleInstance) {
          vConsoleInstance = new VConsole({
            theme: VCONSOLE_CONFIG.theme,
            defaultPlugins: VCONSOLE_CONFIG.defaultPlugins,
            maxLogNumber: VCONSOLE_CONFIG.maxLogNumber,
            onReady: function() {
              console.log('[VConsole] VConsole is ready!');
            },
            onClearLog: function() {
              console.log('[VConsole] Logs cleared');
            }
          });
          
          console.log('[VConsole] VConsole enabled for debugging');
          
          // 将 VConsole 实例挂载到 window 上，方便调试
          if (typeof window !== 'undefined') {
            window.vConsole = vConsoleInstance;
          }
        }
      }, 100);
    } catch (e) {
      console.error('[VConsole] Failed to initialize:', e);
    }
  } else {
    console.log('[VConsole] VConsole is disabled (configured in vconsole.config.js)');
  }
};

// 立即初始化（如果配置启用）
initVConsole();

// 如果 DOM 还未准备好，等待 DOMContentLoaded 事件
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVConsole);
  }
  
  // 也监听 window.onload，确保所有资源加载完成
  if (typeof window !== 'undefined') {
    window.addEventListener('load', () => {
      // 如果之前没有初始化成功，再次尝试
      if (!vConsoleInstance && VCONSOLE_ENABLED) {
        initVConsole();
      }
    });
  }
}

const app = createApp(App)

app.use(ElementPlus)
app.mount('#app')